var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClapperTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 62,
    viewBox: "0 0 402 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.38 37.08L2.79004 36.88L3.27004 6.66L22.06 6.77L40.06 30.26C40.3062 30.7604 40.4297 31.3124 40.42 31.87L40.38 37.08Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400.98 56.62L23.28 59.14L2.46997 59.83L2.21997 35.92L401.59 33.26L400.98 56.62Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.04 58.35L142.19 34.92L195.12 34.64L179.25 58.07L126.04 58.35Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.92 59.03L42.06 35.58L94.99 35.31L79.13 58.75L25.92 59.03Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.88 57.62L243.03 34.18L295.95 33.9L280.09 57.34L226.88 57.62Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M324.68 57.01L340.82 33.57L393.75 33.3L377.89 56.73L324.68 57.01Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31001 59.51L23.28 59.14L400.91 54.94L398.51 56.63L22.03 61.95H2.26001L2.31001 59.51Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M32 30.85L21.78 30.97L0.25 18.17L0.379999 7.06001L23.69 6.79001L32.45 29.2L32 30.85Z",
    fill: "#090906"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M400.48 24.85L22.75 29.31L1.21997 16.52L1.34997 5.41L400.75 0.690002L400.48 24.85Z",
    fill: "#4A4A4A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.84 3.95L141 27.93L193.93 27.3L179.06 3.32001L125.84 3.95Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7 5.10999L40.86 29.09L93.8 28.47L78.9199 4.48999L25.7 5.10999Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M226.69 2.71001L241.85 26.69L294.78 26.06L279.9 2.08002L226.69 2.71001Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M324.49 1.64999L339.65 25.62L392.59 25L377.71 1.01999L324.49 1.64999Z",
    fill: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9925 20.7408C23.395 19.4026 25.0864 15.6054 23.7704 12.2595C22.4545 8.91363 18.6295 7.28607 15.227 8.62426C11.8246 9.96245 10.1332 13.7597 11.4492 17.1055C12.7651 20.4514 16.5901 22.079 19.9925 20.7408Z",
    fill: "#D5D5D5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5901 9.91C18.1185 9.79016 18.6656 9.77757 19.1989 9.87298C19.7323 9.96838 20.2411 10.1698 20.6952 10.4654C21.1493 10.761 21.5395 11.1447 21.8427 11.5938C22.1458 12.0429 22.3557 12.5483 22.4601 13.08C23.6401 17.17 20.5601 18.27 20.5601 18.27C20.5601 18.27 20.0301 19.17 20.3301 19.48C20.8801 20.04 22.5201 19.74 23.4601 16.38C24.9601 11.01 19.1601 8.65 19.1601 8.65C19.1601 8.65 17.4601 8.18 16.9801 9C16.5001 9.82 16.7901 10.17 17.5901 9.91Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 10.64C14.9999 10.64 16.3399 10.64 16.0599 10.04C15.7799 9.44 15.2399 9.28 14.5199 9.79C13.7999 10.3 12.5199 11.01 12.9799 11.33C13.4399 11.65 14.9999 10.64 14.9999 10.64Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7647 15.7814C18.4482 15.5126 18.7893 14.753 18.5266 14.0848C18.2638 13.4167 17.4966 13.093 16.813 13.3618C16.1295 13.6307 15.7883 14.3903 16.0511 15.0584C16.3139 15.7266 17.0811 16.0503 17.7647 15.7814Z",
    fill: "#A9A9A9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.34 20.59C20.34 20.59 14.69 22.08 12.62 17.92C10.55 13.76 12 11.33 12 11.33C11.2719 12.3386 10.88 13.551 10.88 14.795C10.88 16.039 11.2719 17.2514 12 18.26C15.09 23.09 20.34 20.59 20.34 20.59Z",
    fill: "#A9A9A9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapperTop);
export default __webpack_public_path__ + "static/media/clapper-top.e77c7e8c37a5f09196af5d842285767e.svg";
export { ForwardRef as ReactComponent };